import _ from 'lodash';
import BakeasyTextField, { BakeasyTextFieldProps } from './BakeasyTextField';
import { t } from 'i18next';
import * as Regex from '../../constants/Regex';
function BakeasyTextFieldUsername(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('USERNAME')}
      type="text"
      name="username"
      placeHolder={t('ENTER_YOUR_USERNAME')}
      required={props?.required}
      disabled={props?.disabled}
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
    />
  );
}

export default BakeasyTextFieldUsername;

export function BakeasyTextFieldEmailId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      type="email"
      name="email"
      required={true}
      value={props?.value}
      maxLength={30}
      regexPattern={Regex.emailId}

      label={t('EMAIL_ID')}
      placeHolder={t('ENTER') + _.toLower(t('EMAIL_ID'))}
      onChange={props?.onChange}
    />
  );
}
